module.exports = __webpack_public_path__ + "static/media/sample-photo.77a9191c.png";


//////////////////
// WEBPACK FOOTER
// ./src/data/sample-photo.png
// module id = 33
// module chunks = 0